/* LOCATION */
const actionTypes = Object.freeze({
    CLEAR_STATE: 'LOCATIONS/CLEAR_STATE',
    GET_COUNTRIES: 'LOCATIONS/GET_COUNTRIES',
    GET_PHONE_CODES: 'LOCATIONS/GET_PHONE_CODES'
});

export default actionTypes;